import styled from 'styled-components'

export const StyledHeading = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 8px;
    gap: 8px;
    position: relative;
`

export const StyledWhite = styled.div`
    color: ${({ theme }) => theme.colours.font.primary};
    font-size: 20px;
    font-weight: normal;
    white-space: nowrap;
`

export const StyledGreen = styled.span`
    color: ${({ theme }) => theme.colours.font.green};
`

export const StyledExpiringContainer = styled.div`
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.colours.background.red};
    font-size: 13px;
    border-radius: 4px;
    padding: 8px 12px;
    margin: 0 12px 12px 12px;
    position: relative;
    a {
        color: ${({ theme }) => theme.colours.font.primary};
        text-decoration: underline;
        margin-left: auto;
    }
`

export const StyledCloseButton = styled.div`
    position: absolute;
    top: -13px;
    right: -13px;
    color: ${({ theme }) => theme.colours.font.primary};
    cursor: pointer;
`

export const StyledLeftSection = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`

export const StyledLogoGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: ${({ theme }) => theme.colours.background.dark_blue};
    border-radius: 8px;
    padding: 6px 12px 6px 8px;
`

export const StyledRightSection = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
`

export const StyledHamburgerButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colours.font.primary};
    font-size: 22px;
    padding: 0;
`

// Overlay backdrop
export const StyledMenuOverlay = styled.div<{ $isOpen: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
    visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
    transition: opacity 0.3s ease, visibility 0.3s ease;
`

// Slide-in side panel
export const StyledHamburgerMenu = styled.div<{ $isOpen: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 240px;
    background-color: ${({ theme }) => theme.colours.background.blue};
    z-index: 1000;
    padding: 16px 0;
    box-shadow: 4px 0 16px 0px
        ${({ theme }) => theme.colours.background.transparent_black};
    transform: translateX(${({ $isOpen }) => ($isOpen ? '0' : '-100%')});
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
`

export const StyledMenuHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px 16px 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colours.border.grey};
    margin-bottom: 8px;
`

export const StyledMenuCloseButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colours.font.primary};
    font-size: 22px;
    padding: 0;
`

export const StyledHamburgerLink = styled.a`
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    color: ${({ theme }) => theme.colours.font.primary};
    padding: 10px 16px;
    font-size: 13px;
    transition: color 0.15s ease;
    &:hover {
        color: ${({ theme }) => theme.colours.font.green};
        cursor: pointer;
    }
`

export const StyledHamburgerLinkIcon = styled.div`
    font-size: 18px;
    display: flex;
    align-items: center;
`

export const StyledCollapseButton = styled.button`
    background-color: ${({ theme }) => theme.colours.background.dark_blue};
    border: none;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colours.font.primary};
    font-size: 18px;
    width: 30px;
    height: 30px;
    padding: 0;
`
